import React, { useState, Fragment } from 'react';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import { Row, Collapse } from 'reactstrap';
import ExampleResponse from './ExampleResponse';
import BotResponseButton from '../ApiButtons/BotResponseButton';
import MessageResponse from './MessageResponse';
import LinkResponse from './LinkResponse';
import ImageCarouselResponse from './ImageCarouselResponse';
import { faEdit, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import { putAPI_Update_Response } from '../../../../../../constants/APIs';
import VideoResponse from './VideoResponse';
import Validation from '../../../../../../components/Validation';
export default function ChildButtonsResponse({ elem, reloadBotResponse, propertyId, type, button, index, selectedLang, viewResponse, historyUpdator, ishistory, isButtonShow }) {
    const [open, setOpen] = useState(false);
    const [msg, setMsg] = useState([]);
    const [isEditingButtonText, setIsEditingButtonText] = useState(false);
    const [isAddApiButton, setIsAddApiButton] = useState(false);
    const [isEditingButtonMessageText, setIsEditingButtonMessageText] = useState(false);

    const toggleButtonAddedd = () => {
        toggleButtonText()
    };
    const toggleButtonMessageAddedd = () => {
        toggleButtonMessageText()
    };
    const toggleButtonMessageText = () => {
        setIsEditingButtonMessageText(!isEditingButtonMessageText);
    };
    const toggleButtonText = () => {
        setIsEditingButtonText(!isEditingButtonText);
    };

    const renderSwitch = (button, index) => {
        switch (button.response.type) {
            case 'example':
                return (
                    <Fragment key={index}>
                        <ExampleResponse
                            elem={{ ...button }}
                            reloadBotResponse={reloadBotResponse}
                            child={1}
                            viewResponse={viewResponse}
                            selectedLang={selectedLang}
                            historyUpdator={historyUpdator}
                            isLogHistory={ishistory === true ? true : false}
                            isButtonShow={isButtonShow}
                        />
                    </Fragment>
                );

            case 'messages':
                return (
                    <Fragment key={index}>
                        <MessageResponse
                            elem={{ ...button }}
                            reloadBotResponse={reloadBotResponse}
                            child={1}
                            viewResponse={viewResponse}
                            selectedLang={selectedLang}
                            historyUpdator={historyUpdator}
                            isLogHistory={ishistory === true ? true : false}
                            isButtonShow={isButtonShow}
                        />
                    </Fragment>
                );

            case 'messages-link':
                return (
                    <Fragment key={index}>
                        <LinkResponse
                            elem={{ ...button }}
                            reloadBotResponse={reloadBotResponse}
                            child={1}
                            viewResponse={viewResponse}
                            selectedLang={selectedLang}
                            historyUpdator={historyUpdator}
                            isLogHistory={ishistory === true ? true : false}
                            isButtonShow={isButtonShow}
                        />
                    </Fragment>
                );

            case 'messages-image-carousel':
                return (
                    <Fragment key={index}>
                        <ImageCarouselResponse
                            elem={{ ...button }}
                            reloadBotResponse={reloadBotResponse}
                            child={1}
                            viewResponse={viewResponse}
                            selectedLang={selectedLang}
                            historyUpdator={historyUpdator}
                            isLogHistory={ishistory === true ? true : false}
                            isButtonShow={isButtonShow}
                        />
                    </Fragment>
                );
            case 'messages-video':
                return (
                    <Fragment key={index}>
                        <VideoResponse
                            elem={{ ...button }}
                            reloadBotResponse={reloadBotResponse}
                            child={1}
                            viewResponse={viewResponse}
                            selectedLang={selectedLang}
                            historyUpdator={historyUpdator}
                            isLogHistory={ishistory === true ? true : false}
                            isButtonShow={isButtonShow}
                        />
                    </Fragment>
                );

            default:
                break;
        }
    }
    const handleDeleteButton = (code, messages, url, caption, button, buttonCode) => {
        let postData = {
            GroupId: getGroupID(),
            Code: code,
            Language: `${selectedLang === 'en' ? 'en-US' : selectedLang}`,
            Channel: 'WebsiteDirectLine',
            PropertyId: propertyId,
            Default: {
                Messages: messages,
                Url: url,
                Caption: caption,
                apiButtons: [{ text: button.query.buttonText, value: button.query.code, deleted: true }]
            },
            Overrides: {},
            UserName: historyUpdator
        }
        AxiosAPI({
            method: 'put',
            url: `${putAPI_Update_Response}`,
            data: postData,
        }).then(res => {
            if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
                && res.data.Messages !== null && res.data.Messages.length > 0) {
                setMsg(res.data.Messages);
                setOpen(true);
            } else {
                setTimeout(() => {
                    reloadBotResponse();
                }, 1000)
            }
        })
            .finally(

        );
    }

    const handleDeleteImageButton = (code, messages, urls, captions, button, buttonCode) => {
        let imageList = [];
        imageList = urls.map((url, index) => {
            const imgCaption = captions[index];
            return { Url: url, Caption: imgCaption };
        });
        let postData = {
            GroupId: getGroupID(),
            Code: code,
            Language: `${selectedLang === 'en' ? 'en-US' : selectedLang}`,
            Channel: 'WebsiteDirectLine',
            PropertyId: propertyId,
            Default: {
                Messages: messages,
                Images: imageList,
                apiButtons: [{ text: button.query.buttonText, value: button.query.code, deleted: true }]
            },
            Overrides: {},
            UserName: historyUpdator
        }
        AxiosAPI({
            method: 'put',
            url: `${putAPI_Update_Response}`,
            data: postData,
        })
            .then(res => {
                if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
                    && res.data.Messages !== null && res.data.Messages.length > 0) {
                    setMsg(res.data.Messages);
                    setOpen(true);
                } else {
                    setTimeout(() => {
                        reloadBotResponse();
                    }, 1000)
                }
            })
            .finally(

        );
    }

    const handleDeleteMessageButton = (code, messages, button) => {
        let postData = {
            GroupId: getGroupID(),
            Code: code,
            Language: `${selectedLang === 'en' ? 'en-US' : selectedLang}`,
            Channel: 'WebsiteDirectLine',
            PropertyId: propertyId,
            Default: messages,
            Overrides: {},
            apiButtons: [{ text: button.query.buttonText, value: button.query.code, deleted: true }],
            UserName: historyUpdator
        }
        AxiosAPI({
            method: 'put',
            url: `${putAPI_Update_Response}`,
            data: postData,
        })
            .then(res => {
                if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
                    && res.data.Messages !== null && res.data.Messages.length > 0) {
                    setMsg(res.data.Messages);
                    setOpen(true);
                } else {
                    setTimeout(() => {
                        reloadBotResponse();
                    }, 1000)
                }
            })
            .finally(

        );
    }
    const handleDeleteVideoButton = (code, messages, urls, captions, button, buttonCode) => {
        let videoList = [];
        videoList = urls.map((url, index) => {
            const videoCaption = captions[index];
            return { Url: url, Caption: videoCaption };
        });
        let postData = {
            GroupId: getGroupID(),
            Code: code,
            Language: `${selectedLang === 'en' ? 'en-US' : selectedLang}`,
            Channel: 'WebsiteDirectLine',
            PropertyId: propertyId,
            Default: {
                Messages: messages,
                Videos: videoList,
                apiButtons: [{ text: button.query.buttonText, value: button.query.code, deleted: true }]
            },
            Overrides: {},
            UserName: historyUpdator
        }
        AxiosAPI({
            method: 'put',
            url: `${putAPI_Update_Response}`,
            data: postData,
        })
            .then(res => {
                if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
                    && res.data.Messages !== null && res.data.Messages.length > 0) {
                    setMsg(res.data.Messages);
                    setOpen(true);
                } else {
                    setTimeout(() => {
                        reloadBotResponse();
                    }, 1000)
                }
            })
            .finally(

        );
    }
    return (
        <Fragment>
            <Colxx xxs="12" xs="12" style={{ border: 'solid 1px #4556ac', margin: '5px', padding: '10px' }} index={index} >
                <h3 style={{ display: 'inline-block', marginRight: '10px', color: 'var(--theme-color-1)' }}>{button.query.buttonText}</h3>
                {/* <FontAwesomeIcon
                    icon={faEdit}
                    color="#90caf9"
                    cursor="pointer"
                    onClick={toggleButtonText}
                /> */}

                {/* <b> | </b> */}
                {viewResponse !== true && isButtonShow && type === 'messages' && (
                    <Fragment>
                        <FontAwesomeIcon
                            icon={faEdit}
                            color="#90caf9"
                            cursor="pointer"
                            onClick={toggleButtonMessageText}
                        />
                        <b> | </b>
                        <FontAwesomeIcon
                            icon={faTrashAlt}
                            style={{ color: 'var(--theme-color-1)' }}
                            cursor="pointer"
                            onClick={() => handleDeleteMessageButton(elem.query.code, elem.response.messages, button)}
                        />
                        <Collapse isOpen={isEditingButtonMessageText}> <Row>
                            <Colxx md="1" className="mb-2">
                            </Colxx>
                            <Colxx md="5" className="mb-2 p-4" style={{ border: 'solid 1px #4556ac' }}><BotResponseButton
                                isAdd={isAddApiButton}
                                index={0}
                                code={elem.query.code}
                                messages={elem.response.messages}
                                setIsAddImageToFalse={() => setIsAddApiButton(false)}
                                reloadBotResponse={reloadBotResponse}
                                type={type}
                                toggleButtonAddedd={toggleButtonAddedd}
                                buttonText={button.query.buttonText}
                                buttonValue={button.query.code}
                                toggleButtonMessageAddedd={toggleButtonMessageAddedd}
                                selectedLang={selectedLang}
                                historyUpdator={historyUpdator}
                            /></Colxx>
                        </Row></Collapse>
                    </Fragment>
                )}
                {viewResponse !== true && isButtonShow && type === 'link' && (
                    <Fragment>
                        <FontAwesomeIcon
                            icon={faEdit}
                            color="#90caf9"
                            cursor="pointer"
                            onClick={toggleButtonText}
                        />
                        <b> | </b>
                        <FontAwesomeIcon
                            icon={faTrashAlt}
                            style={{ color: 'var(--theme-color-1)' }}
                            cursor="pointer"
                            onClick={() => handleDeleteButton(elem.query.code, elem.response.messages, elem.response.details.url, elem.response.details.caption, button)}
                        />
                        <Collapse isOpen={isEditingButtonText}> <Row>
                            <Colxx md="1" className="mb-2">
                            </Colxx>
                            <Colxx md="5" className="mb-2 p-4" style={{ border: 'solid 1px #4556ac' }}><BotResponseButton
                                link={elem.response.details.url}
                                caption={elem.response.details.caption}
                                isAdd={isAddApiButton}
                                index={0}
                                code={elem.query.code}
                                messages={elem.response.messages}
                                setIsAddImageToFalse={() => setIsAddApiButton(false)}
                                reloadBotResponse={reloadBotResponse}
                                type={type}
                                toggleButtonAddedd={toggleButtonAddedd}
                                buttonText={button.query.buttonText}
                                buttonValue={button.query.code}
                                urls={elem.response.details.urls}
                                captions={elem.response.details.captions}
                                toggleButtonMessageAddedd={toggleButtonMessageAddedd}
                                selectedLang={selectedLang}
                                historyUpdator={historyUpdator}
                            /></Colxx>
                        </Row></Collapse>
                    </Fragment>
                )}
                {viewResponse !== true && isButtonShow && type === 'imagecarousel' && (
                    <Fragment>
                        <FontAwesomeIcon
                            icon={faEdit}
                            color="#90caf9"
                            cursor="pointer"
                            onClick={toggleButtonText}
                        />
                        <b> | </b>
                        <FontAwesomeIcon
                            icon={faTrashAlt}
                            style={{ color: 'var(--theme-color-1)' }}
                            cursor="pointer"
                            onClick={() => handleDeleteImageButton(elem.query.code, elem.response.messages, elem.response.details.urls, elem.response.details.captions, button)}
                        />
                        <Collapse isOpen={isEditingButtonText}> <Row>
                            <Colxx md="1" className="mb-2">
                            </Colxx>
                            <Colxx md="5" className="mb-2 p-4" style={{ border: 'solid 1px #4556ac' }}><BotResponseButton
                                link={elem.response.details.url}
                                caption={elem.response.details.caption}
                                isAdd={isAddApiButton}
                                index={0}
                                code={elem.query.code}
                                messages={elem.response.messages}
                                setIsAddImageToFalse={() => setIsAddApiButton(false)}
                                reloadBotResponse={reloadBotResponse}
                                type={type}
                                toggleButtonAddedd={toggleButtonAddedd}
                                buttonText={button.query.buttonText}
                                buttonValue={button.query.code}
                                urls={elem.response.details.urls}
                                captions={elem.response.details.captions}
                                toggleButtonMessageAddedd={toggleButtonMessageAddedd}
                                selectedLang={selectedLang}
                                historyUpdator={historyUpdator}
                            /></Colxx>
                        </Row></Collapse>
                    </Fragment>
                )}
                {viewResponse !== true && isButtonShow && type === 'video' && (
                    <Fragment>
                        <FontAwesomeIcon
                            icon={faEdit}
                            color="#90caf9"
                            cursor="pointer"
                            onClick={toggleButtonText}
                        />
                        <b> | </b>
                        <FontAwesomeIcon
                            icon={faTrashAlt}
                            style={{ color: 'var(--theme-color-1)' }}
                            cursor="pointer"
                            onClick={() => handleDeleteVideoButton(elem.query.code, elem.response.messages, elem.response.details.urls, elem.response.details.captions, button)}
                        />
                        <Collapse isOpen={isEditingButtonText}> <Row>
                            <Colxx md="1" className="mb-2">
                            </Colxx>
                            <Colxx md="5" className="mb-2 p-4" style={{ border: 'solid 1px #4556ac' }}><BotResponseButton
                                link={elem.response.details.url}
                                caption={elem.response.details.caption}
                                isAdd={isAddApiButton}
                                index={0}
                                code={elem.query.code}
                                messages={elem.response.messages}
                                setIsAddImageToFalse={() => setIsAddApiButton(false)}
                                reloadBotResponse={reloadBotResponse}
                                type={type}
                                toggleButtonAddedd={toggleButtonAddedd}
                                buttonText={button.query.buttonText}
                                buttonValue={button.query.code}
                                urls={elem.response.details.urls}
                                captions={elem.response.details.captions}
                                toggleButtonMessageAddedd={toggleButtonMessageAddedd}
                                selectedLang={selectedLang}
                                historyUpdator={historyUpdator}
                            /></Colxx>
                        </Row></Collapse>
                    </Fragment>
                )}

                {renderSwitch(button, index)}
            </Colxx>
            <Validation open={open} messages={msg} toggle={() => { setOpen(!open) }}></Validation>
        </Fragment>
    );
}
